export default {
  // Languages
  'English': '',
  'Français': '',
  'עברית': '',

  // Menu
  'Carts': '',
  'Orders': '',
  'Customers': '',
  'Products': '',
  'Disconnected': '',
  'My Account': '',
  'Dark': '',
  'Light': '',
  'Logout': '',
  'Dashboard': '',
  'Auth': '',
  'Campaigns': '',
  'Catalog': '',
  'All Customers': '',
  'Groups': '',
  'Sales': '',
  'Fullscreen': '',
  'Notifications': '',
  'Store Settings': '',
  '{0} unread notifications': '',
  'Store Management': '',

  // ToS
  'Something went wrong while creating new ToS. Please try again.': '',
  'Admin Terms of Service': '',
  'Customer Terms of Service': '',
  'Require ToS acceptance': '',
  'I have read and agree to the FutureEcom': '',
  'Terms of Service': '',

  // Common
  'Point of Sale': '',
  'Customer': '',
  'Simple': '',
  'Labeled': '',
  'Confirm': '',
  'Subtotal': '',
  'Discounts': '',
  'Taxes': '',
  'Total': '',
  'Order': '',
  'E-mail': '',
  'Shipping Address': '',
  'Billing Address': '',
  'Save': 'tt',
  'Reset': '',
  'Summary': '',
  'Delete': '',
  'Update': '',
  'Items': '',
  'Yes, that\'s fine': '',
  'Danger Zone': '',
  'Please Confirm': '',
  'Price': '',
  'Sale Price': '',
  'Gross Price': '',
  'Gross Sale Price': '',
  'Net With Discount': '',
  'VAT': '',
  'VAT name': '',
  'VAT %': '',
  'Yes': '',
  'No': '',
  'Add': '',
  'Submit': '',
  'Created From': '',
  'Creation Source': '',
  'General': '',
  'Updated At': '',
  'Back': '',
  'Created From:': '',
  'Created By:': '',
  'Allowed Applications': '',
  'StoreFront': '',
  'Payment Settings': '',
  'Taxes Settings': '',
  'Total items amount': '',
  'Total items count': '',
  'Items type': '',
  'Shipping region': '',
  'is': '',
  'not': '',
  'does not equals': '',
  'contains': '',
  'does not contain': '',
  'is empty': '',
  'is not empty': '',
  'begins with': '',
  'ends with': '',

  // Credentials
  'Login': '',
  'Password': '',
  'Forgot Password?': '',
  'Remember password? Log In!': '',
  'Send Reset Link': '',
  'New Password': '',
  'Reset Password': '',
  'Password Confirmation': '',
  'Account saved': '',

  // Customer Info
  'First Name': '',
  'Last Name': '',
  'Date of Birth': '',
  'Date Of Birth': '',
  'Telephone': '',
  'Street': '',
  'City': '',
  'State': '',
  'Country': '',
  'Post code': '',
  'Company': '',

  // Product Info
  'Available': '',
  'Availability': '',
  'Min per order': '',
  'Max per order': '',
  'In Stock': '',
  'Policy': '',
  'Quantity': '',
  'continue': '',
  'stop': '',
  'Track Inventory': '',
  'Restockable Item': '',
  'Product Type': '',
  'physical': '',
  'digital': '',
  'downloadable': '',
  'Product Restrictions': '',
  'Bundle exclusive': '',
  'Type to create': '',
  'Reset Inventory': '',
  'Allowed Groups': '',
  'When group is being selected, this product will become available only for it <br> becoming automatically unavailable for other customer groups. <br> When no group is selected, then product is available for all.': '',
  'Update Variants': '',
  'Updates Variations based on Options changes, without re-creating unaffected Variations. Will not add and generate new Variant set.': '',
  'Regardless of the changes in Variants, it will always re-create all the Variations based on current Variants options.': '',
  'Variants updated': '',
  'Update Attributes': '',
  'Select attributes to update': '',
  'Will propagate selected Attributes from Parent product to selected Variations.': '',
  'Translations': '',
  'Application Restrictions': '',
  'Related Products/Taxonomy': '',
  'Customer Groups Restrictions': '',
  'Sort by quantity': '',
  'Tier Price': '',
  'Gross Tier Price': '',
  'Add tier': '',
  'Base Prices': '',
  'Price tiers': '',
  'Tier Prices': '',
  'Variations attributes updated': '',
  'Applicable Tier Prices': '',

  // Dashboard
  'Create Order': '',
  'Site Traffic': '',
  'Top Location': '',
  'Conversion': '',
  'Increase': '',
  'Decrease': '',
  'Refunds': '',
  'Unique Visit': '',
  'Page View': '',
  'Other': '',

  // Page Titles
  'Quotes': '',
  'Account': '',

  // Action Buttons
  'Create': '',
  'Create Quote': '',
  'Place Order': '',
  'Hold': '',
  'Invoice': '',
  'Add new Customer': '',
  'Cancel': '',
  'Release': '',

  // Cart Creation Page
  'All': '',
  'All Categories': '',
  'Note Type': '',
  'Add Note': '',
  'Simple Note': '',
  'Label': '',
  'Values': '',
  'Add Product': '',
  'Added Items': '',
  'Note': '',
  'Shipping Method': '',
  'Coupon': '',
  'Code': '',
  'Add Coupon': '',
  'Apply': '',
  'Applied': '',
  'Variants': '',
  'Edit': '',
  'Search products by name': '',
  'Details': '',
  'Set As Guest': '',
  'Search by last name': '',
  'Create Customer and Save': '',
  'Fill Address': '',
  'productsPagination': '{page} of {total}', // replace "of"
  'Coupon Code': '',
  'Nothing to show': '',
  'Customer Details': '',
  'Order Note': '',
  'Properties': '',
  'Product': '',
  'Select Payment Method': '',
  'Place': '',
  'Set Method': '',
  'Required!': '',
  'Notes': '',
  'No products to show': '',
  'Draft Order Saved': '',
  'Cannot find order created from this Cart. Redirecting to Orders list.': '',
  'There are no shipping methods available.': '',
  'Draft Order ': '',
  'New Order': '',
  'Order Items': '',
  'Add Item': '',
  'Quotes deleted successfully.': '',
  'Please choose a variant': '',
  'Select options': '',

  // Order Page
  'Refund': '',
  'Post': '',
  'Status': '',
  'Archive': '',
  'Ship Items': '',
  'Mark as Paid': '',
  'guest': '',
  'processing': '',
  'approved': '',
  'placed': '',
  'shipped': '',
  'partially shipped': '',
  'on_hold': '',
  'refunded': '',
  'canceled': '',
  'completed': '',
  'unfulfilled': '',
  'Leave a comment...': '',
  'Unit Price': '',
  'Row Total': '',
  'Total Discount': '',
  'Total Taxes': '',
  'includes discounts': '',
  'Hold Reasons': '',
  'Guest': '',
  'Payment Method': '',
  'Payment from': '',
  'via': '',
  'Timeline': '',
  'Shipment': '',
  'Carrier': '',
  'Tracking number': '',
  'Please select items to refund': '',
  'Please select refund options': '',
  'Notify Customer': '',
  'Re-stock items': '',
  'Refund Items': '',
  'Refund order': '',
  'Added shipment': '',
  'Order marked as paid': '',
  'Put on hold': '',
  'Are you sure that you want to mark this order as paid?': '',
  'markOrderAsPaid': 'Mark order #{order} as paid', // replace all beside {order}
  'Hold Reason': '',
  'Please write the hold reason': '',
  'Created By': '',
  'Resolved At': '',
  'Item Count': '',
  'Please write the hold reason:': '',
  'Timeline Track': '',
  'Created at:': '',
  'Resolved at:': '',
  'Fulfill order': '',
  'SKU:': '',
  'Ship': '',
  'Mark order {0} as paid': '',
  'Mark as paid': '',
  'Manage': '',
  'Type, select or create': '',
  'Capture': '',
  'Please select items to refund:': '',
  'qty': '',
  'Please select refund options:': '',
  'Notify customer': '',
  'Refund order {0}': '',
  'Order Summary': '',
  'items': '',
  'Shipped': '',
  'Unfulfilled': '',
  'Shipped by {0}': '',
  'Tax:': '',
  'Item:': '',
  'Search customers by last name': '',
  'Search products by name or SKU': '',
  'New Note': '',
  'You can either add only simple notes or labeled notes to item': '',
  'Shipping method': '',
  'Order note': '',
  'Set Note': '',
  'Shipping and packaging': '',
  '{0} items': '',
  'Select Address': '',
  'Manage Addresses': '',
  'Add to track': '',
  'Comment': '',
  'Set status': '',
  'Address': '',
  'Get Invoice': '',
  'Tracking Timeline': '',
  'Order Delivery Information': '',
  'Total price:': '',
  '{0} in stock': '',
  'Payment captured': '',
  'Order marked as paid.': '',
  'Orders canceled successfully.': '',
  'Selected item is already in cart': '',
  'Order Discount': '',
  'Items Discount': '',
  'There is no invoice associated with this order.': '',
  'Order refunded.': '',
  'Created At:': '',
  'Documents': '',
  'created': '',
  'status:': '',
  '(online)': '',
  'There is no authorization that can be captured.': '',
  'Refund Offline': '',
  'Refunded': '',
  'Provider': '',
  'Transaction type': '',
  'Payment type': '',
  'Payment transactions': '',
  'New': '',
  'Pending': '',
  'Finished': '',
  'Error': '',
  'Canceled': '',

  // Campaigns
  'Type': '',
  'Start Date': '',
  'End Date': '',
  'Discount type': '',
  'Rate type': '',
  'Discount Target': '',
  'Determines what kind of coupon it is': '',
  'Discount Priority': '',
  'Exclusive': '',
  'Customer Groups allowed to use this promotion. <br> Leave empty to allow everyone.': '',
  'Conditions': '',
  'If': '',
  'of the following true:': '',
  'group': '',
  'condition': '',
  'Remove group': '',
  'Remove condition': '',
  'any': '',
  'all': '',
  'Discount details': '',
  'Active': '',
  'Discount Name': '',
  'Rate': '',
  'Discount Description': '',
  'Active dates': '',
  'Starts at': '',
  'Ends at': '',
  'Coupon code': '',
  'Maximum uses per customer': '',
  'Maximum total uses': '',
  'For example HAPPYSALE2019': '',
  'Target conditions': '',
  'Add target': '',
  'Select type of target': '',
  'Remove target': '',
  'Product type': '',
  'Product\'s SKU\'s': '',
  'Product\'s names': '',
  'Product\'s brands': '',
  'Values, comma separated': '',
  'Target condition determines on what <br> kind of products the campaign affects': '',
  'Add Discount': '',
  'Discount saved': '',
  'Campaigns deleted successfully.': '',
  'Included In Discount': '',
  'Excluded From Discount': '',

  // Product Page
  'unlimited': '',
  'Inventory': '',
  'Variants Options': '',
  'Images': '',
  'Slug': '',
  'Taxonomy': '',
  'Brand': '',
  'Description': '',
  'Tags': '',
  'Product Variations': '',
  'Search Variation': '',
  'No properties': '',
  'No Variants': '',
  'Policy (allows customer to purchase out of stock item)': '',
  'Store Brand settings, like logo.': '',
  'Create Product': '',
  'Export': '',
  'Import': '',
  'Products Export': '',
  'Products Import': '',
  'Include products children in exported file.': '',
  'Update existing products.': '',
  'Select...': '',
  'Clear': '',
  'Products exported. Please save the file.': '',
  'Products imported.': '',
  'Bundle': '',
  'Add Items': '',
  'Search in products and variants...': '',
  'Name and Description': '',
  'Insert title...': '',
  'slug': '',
  'Add Image': '',
  'Default image': '',
  'Select default image': '',
  'Default image not selected, placeholder will be used instead': '',
  'Upload image file': '',
  'Image url': '',
  'Image url is required': '',
  'Image url must be valid': '',
  'Select Method': '',
  'Save Image': '',
  'Restock/Deduct Quantity': '',
  'Restock': '',
  'Deduct': '',
  'Allow customers to purchase this product when out of stock': '',
  'Track inventory': '',
  'Quantity updated': '',
  'Quantity won\'t change when product inventory is not tracked.': '',
  'Add option': '',
  'Generate Variants': '',
  'Variants generated': '',
  'Product Option Removal': '',
  'This operation will regenerate all variants. Do you want to continue?': '',
  'Option deleted': '',
  'Variant Options': '',
  'Pricing': '',
  'Sale price': '',
  'Add Property': '',
  'Value': '',
  'Search engine listing preview': '',
  'Product Variants': '',
  'Save and close': '',
  'Duplicate': '',
  'Single name': '',
  'Product count': '',
  'Full taxonomy': '',
  '{0} saved': '',
  'Error saving taxonomy': '',
  '{0} deleted': '',
  'Error deleting taxonomy': '',
  'Taxonomies deleted successfully.': '',
  'Create taxonomy': '',
  'Taxonomy name': '',
  'Subtaxonomy': '',
  'Parent taxonomy': '',
  'Children taxonomy': '',
  'New Taxonomy': '',
  'Products deleted successfully.': '',
  'Provide Image url': '',
  'Taxonomy saved': '',
  'Bundle Components': '',
  'Add components': '',

  // Customer Page
  'Personal Information': '',
  'Customer Group': '',
  'New Customer': '',
  'Subscription': '',
  'Group': '',
  'Addresses': '',
  'Search Address': '',
  'Add New': '',
  'No orders yet for this customer': '',
  'Default': '',
  'Show Less': '',
  'Show More': '',
  'Activity Timeline': '',
  'Add new address': '',
  'Points': '',
  'Total money spent': '',
  'Generate password': '',
  'Reset password': '',
  'Password Settings': '',
  'Require password change on first login': '',
  'Customer has been requested to change password on first login attempt.': '',
  'Save new password': '',
  'New password': '',
  'New password confirmation': '',
  'Date of birth': '',
  'For marketing emails': '',
  'Customer Groups': '',
  'Add new Group': '',
  'Group Name': '',
  'Failed to update customer\'s user': '',
  'Customer updated': '',
  'Customers deleted successfully.': '',
  'New Group': '',
  'Customer Groups deleted successfully.': '',
  'Password reset link sent to customer.': '',
  'New password has been generated.': '',
  'New password has been saved.': '',

  // Invoice Page
  'View Order': '',
  'Place Another Order': '',
  'Print Invoice': '',
  'INVOICE NO.': '',
  'ORDER DATE': '',
  'PAYMENT': '',
  'SHIPPING': '',
  'BILL TO': '',
  'SHIP TO': '',
  'ITEM DESCRIPTION': '',
  'QTY': '',
  'PRICE': '',
  'TOTAL': '',
  'Customer Note': '',
  'Discount': '',
  'Sales Taxes': '',
  'Shipping': '',
  'Thanks for choosing our products!': '',
  'Store address is empty. It needs to be set to add it to the invoice footer.': '',
  'Shipping Discount': '',

  // Auth
  'Users': '',
  'Add new User': '',
  'Profile Information': '',
  'Customer ID': '',
  'User Roles': '',
  'Add Roles': '',
  'Add Selected': '',
  'User Permissions': '',
  'Add Permissions': '',
  'Scope': '',
  'App': '',
  'Store': '',
  'Action': '',
  'Resource': '',
  'Role Details': '',
  'Roles': '',
  'Add new Role': '',
  'Role Permissions': '',
  'Role Users': '',
  'Add Users': '',
  'Permissions': '',
  'Add new Permission': '',
  'Permission Details': '',
  'Auth users deleted successfully.': '',
  'Attention': '',
  'You have unsaved changes. Are you sure want to leave?': '',
  'New User': '',
  'Auth roles deleted successfully.': '',
  'New Role': '',
  'Role created': '',
  'Role updated': '',
  'Delete Role': '',
  'Auth permissions deleted successfully.': '',
  'Permission': '',
  'New Permission': '',
  'Permission created': '',
  'User created': '',
  'User updated': '',
  'Delete User': '',

  // Settings
  'Settings': '',
  'General Settings': '',
  'Contact Address': '',
  'Store address used for mailing, store footer and other settings.': '',
  'Region': '',
  'Postcode': '',
  'Currency and Locale': '',
  'Store default currency and default locale. Default currency is used with every resource that has price.': '',
  'Store Currency': '',
  'Store Locale': '',
  'All stores': '',
  'No stores to display': '',
  'Url': '',
  'Create new store': '',
  'Change console primary color': '',
  'Store created successfully.': '',
  'Store creation processes may take a while and some things may appear with a delay.': '',
  'Invalid URL format': '',
  'Base Info': '',
  'Previous': '',
  'Next': '',
  'Store deleted': '',
  'Payments': '',
  'Here you can setup payments': '',
  'Payment method deleted': '',
  'Automatically Pay': '',
  'Add payment method': '',
  'List of available system payment methods.': '',
  'Locations': '',
  'Checkout': '',
  'Languages': '',
  'Here you can setup checkout actions': '',
  'Here you can setup shipping actions': '',
  'Here you can setup notifications': '',
  'Here you can setup store languages': '',
  'Here you can setup localistation': '',
  'Here you can change general setup': '',
  'Here you can change customers settings': '',
  'Here you can setup taxes': '',
  'Default Language': '',
  'Default store language selection': '',
  'Default language determines in what language base attributes of products, shipping methods and others are defined.': '',
  'Changing default language to different one will not swap translations for all entities on the store.': '',
  'This change will only determine in what language current attributes are defined leaving them always as default.': '',
  'For example, when original default language was set to English and it will be changed to Spanish, all the entities will remain with base attributes in English and will require to be changed to Spanish.': '',
  'List of languages available for translations': '',
  'Direction': '',
  'Locale': '',
  'Default language saved': '',
  'Failed to save default language': '',
  'At least one language needs to be defined': '',
  'Cannot remove default language': '',
  'Language created': '',
  'Are you sure you want to delete language?': '',
  'Language deleted': '',
  'Flag': '',
  'Locale ISO': '',
  'Customers Settings': '',
  'Configure customer general settings': '',
  'Require Customer Date of Birth': '',
  'Customers Groups': '',
  'Configure customer groups': '',
  'Customer Default Group': '',
  'Guest Default Group': '',
  'General Tax Settings': '',
  'Apply tax behaviour for whole store': '',
  'Source options:': '',
  '"origin" uses store address to calculate taxes': '',
  '"destination" uses shipping address to calculate taxes. If the shipping type for the order is pickup, then use the store address.': '',
  'The "Ignore Shipping Type" switch determines whether the taxes should take into account of what type shipping method is. When this switch is enabled, shipping method type will be ignored and tax calculation will be based on the source setting. When this switch is not enabled, then any order with shipping of "Pick Up" type will get its taxes calculated based on "origin" (store address), not the destination (shipping address).': '',
  'Based on source:': '',
  'Ignore Shipping Type': '',
  'Tax included in price': '',
  'Tax Rates': '',
  'Customize your tax rate names and % rate.': '',
  'Add tax rates': '',
  'No tax rates to display': '',
  'Rate:': '',
  'Close': '',
  'Tax rates': '',
  'Tax name': '',
  'Tax rate': '',
  'Add more tax rates': '',
  'Tax Groups': '',
  'Customize tax groups, their zone codes, taxonomy and attached tax rates.': '',
  'Add tax group': '',
  'No tax groups to display': '',
  'Add tax rate first': '',
  'Tax group name': '',
  'Select tax rates': '',
  'Select customer group': '',
  'Shipping is taxable': '',
  'Leaving taxonomy field empty will cause tax group to match all products.': '',
  'Select Taxonomy': '',
  'Create your first store': '',
  'Add new zone': '',
  'Zone Settings': '',
  'Localisation': '',
  'Add localisation i.e. country and territories that your store is able to send deliveries': '',
  'Applied and using methods': '',
  'Add shipping method': '',
  'Provide code name': '',
  'Shipping method saved': '',
  'Shipping method has been deleted': '',
  'Error deleting shipping method': '',
  'Payment methods': '',
  'Payment method updated': '',
  'Settings saved': '',
  'Invalid locale format. Valid format: `xx-XX`': '',
  'General Settings:': '',
  'Contact Address:': '',
  'Customer settings saved': '',
  'Update meta': '',
  'Create zone': '',
  'Delete Zone': '',
  'No whitespaces allowed': '',
  'Field cannot be empty': '',
  'Create a store': '',
  'Tax settings updated': '',
  'Tax rates updated': '',
  'Tax group saved': '',
  'Tax group removed': '',
  'Enabled': '',
  'Min delivery days': '',
  'Price type': '',
  'Delivery': '',
  'Pick Up': '',
  'Per item': '',
  'Fixed': '',
  'Loading locations': '',
  'API Key': '',
  'Test mode': '',
  'Client ID': '',
  'Secret Key': '',
  'Merchant ID': '',
  'Application ID': '',
  'Business ID': '',
  'Store ID': '',
  'Public Key': '',
  'Private Key': '',
  'Account number': '',
  'Territory': '',
  'Administrative Area': '',
  'Locality': '',
  'Dependent Locality': '',
  'Included postal codes': '',
  'Excluded postal codes': '',
  'Delete territory': '',
  'Territories': '',
  'Add new territory': '',
  'Territory saved': '',
  'Validation failed': '',
  'Zones:': '',
  'No zones to display, create some!': '',
  'Add item to the list': '',
  'Rules': '',
  'Write a descriptive name and select a primary action for this <br> filter to execute when the rules below are met': '',
  'Disabled': '',
  'Cancel Order': '',
  '(immediately cancel order that meets the rules below)': '',
  'Warning': '',
  '(warn me on admin email)': '',
  'Select appropriate rule(s) to filter the fraudulent activity <br> you are seeing. You can edit these rules at any time.': '',
  'The filter will act on order only if': '',
  'of these conditions are match': '',
  'Advanced filters': '',
  'Options': '',
  'Pick up a few options for this filter': '',
  'Refund transaction amount (if available)?': '',
  'Send cancelation email?': '',
  'Re-stock product inventory?': '',
  'Fraud Rules': '',
  'Checkout validation': '',
  'Order processing validation': '',
  'Admin ID': '',
  'Admin name': '',
  'Contents': '',
  'Contents options': '',
  'content option items': '',
  'ALL': '',
  'ANY': '',
  'equals': '',
  'not equals': '',
  'greater than': '',
  'lower than': '',
  'like': '',
  'BOOL': '',
  'DATE': '',
  'DATETIME': '',
  'Trigger': '',
  'Shipping methods': '',
  'Set your URL': '',
  'or': '',
  'Country code': '',
  'Zone meta info': '',
  'Zone name': '',
  'Zone code': '',
  'Shipping Settings': '',
  'Store Cloudinary credentials (name and preset).': '',
  'Cloud Name': '',
  'Upload Preset': '',
  'Incl. Postcodes': '',
  'Excl. Postcodes': '',
  'The "Discount After Tax" switch determines whether the discount should be applied to the subtotal after taxes have been added to the subtotal': '',
  'Tax Type': '',
  'Discount After Tax': '',
  'General VAT Settings': '',
  'Apply VAT behavior for whole store': '',
  'The "VAT in Price" switch determines whether the product price already has VAT included, or whether the system needs to add the VAT to it.': '',
  'VAT in Price': '',
  'Sales Tax Settings': '',
  'Apply sales tax behavior for whole store': '',
  'VAT Rates': '',
  'Customize your VAT rates.': '',
  'Add VAT rate': '',
  'No VAT rates to display': '',
  'Changing these settings requires products reindex.': '',
  'Region Settings': '',
  'List of countries for which region requirement should be disabled and regions should be hidden.': '',
  'Countries List': '',
  'Settings updated': '',
  'List of disabled notifications or attachments disabled from notifications.': '',
  'Disabling notifications features': '',
  'MAC Address': '',
  'Printers': '',
  'List of allowed printers': '',
  'Automatic printing': '',
  'Printing events': '',
  'List of available printers': '',
  'Documents (invoice/receipt) printing settings': '',
  'Configure StarPrinter integration for automated documents printing': '',
  'Slips': '',
  'Invalid MAC address': '',
  'Footer printed with every document': '',
  'List of notifications types that should be enabled.': '',
  'Enabled Channels': '',
  'Notifications Settings': '',
  'Notifications List': '',
  'Notifications "from"': '',
  'Configure from what address system emails should be send.': '',
  'Emails "from"': '',
  'From Email': '',
  'From Name': '',
  'Emails BCC': '',
  'Configure BCC email and list of templates that should use it.': '',
  'BCC Email': '',
  'Templates list': '',
  'Disabling email notifications': '',
  'List of disabled emails notifications or emails attachments.': '',
  'Disabled Templates': '',
  'Disabled Attachments': '',
  'Email is required when Name is given.': '',
  'Nexmo SMS Credentials': '',
  'Nexmo SMS gateway configuration required for properly working SMS notifications.': '',
  'Key': '',
  'Secret': '',
  'SMS "from"': '',
  'Configure from what name/number system SMS messages should be send.': '',
  'From Name/Number': '',
  'Disabling SMS notifications': '',
  'List of disabled SMS notifications.': '',
  'Device address IP': '',
  'Device address port': '',
  'Currency': '',
  'Time Type': '',
  'Date Type': '',
  'Calendar Type': '',
  'Date Format': '',
  'Console': '',
  'PoS': '',
  'Global': '',
  'Backend': '',
  'Timezone': '',
  'Backend stands for documents and other Application related parts with dates.': '',
  'Store default currency. Default currency is used with every resource that has price.': '',
  'Locale and Timezone': '',
  'Store default locale and timezone with configuration for time format.': '',
  'Locale is being used for dates and currency formatting.': '',
  'Requested Delivery': '',
  'The blackout settings are going to specify what dates, days or hours should not be available for selection by customer.': '',
  'The delivery window specifies how soon the admin should be alerted about the requested delivery date approaching.': '',
  'The time interval is meant to specify at what minutes the delivery can be requested, like at every 15 or every 30.': '',
  'With the delivery enforced (when it is enabled), the store admin will be hinted about requested delivery and that the shipping time approaches.': '',
  'With the requested delivery enabled, the system will let customer choose when he would want his order to arrive.': '',
  'Configuration for a requested delivery date that customer can select at checkout.': '',
  'Enable Requested Delivery': '',
  'Enable Delivery Enforcement': '',
  'Delivery Time Interval': '',
  'Delivery Blackouts Weekdays': '',
  'Delivery Blackouts Hours': '',
  'Delivery Blackouts Days': '',
  'Checkout settings saved': '',
  'Delivery Shipping Window': '',
  'Show Delivery Time': '',
  'Monday': '',
  'Tuesday': '',
  'Wednesday': '',
  'Thursday': '',
  'Friday': '',
  'Saturday': '',
  'Sunday': '',

  // Grids
  'Number': '',
  'Name': '',
  'Items count': '',
  'ID': '',
  'Order Status': '',
  'Created At': '',
  'Email': '',
  'DOB': '',
  'Phone': '',
  'Image': '',
  'SKU': '',
  'Counts': '',
  'Created at': '',
  'Rows per page': '',
  'dataTablePagination': '{start} - {stop} of {total}', // replace "of"
  'Select filter': '',
  'Filters': '',
  'Brands': '',
  'Price from low to high': '',
  'Price from high to low': '',
  'Name (A-Z)': '',
  'Name (Z-A)': '',
  'Newest': '',
  'Search cart by user name': '',
  'Search customer': '',
  'Search order by ID': '',
  'Search product': '',
  'Sort by': '',
  'Email (A-Z)': '',
  'Email (Z-A)': '',
  'Close filters': '',
  'Mass Action': '',
  'Search': '',
  'Deleting records.': '',

  'Blank Page': '',
  'Blank page template': '',
  'Sorry, access denied.': '',
  'Go Home': '',
  'Sorry, the server is down.': '',
  'Try Again': '',
  'Commerce Console': '',
  'Email is required': '',
  'Password reset link has been sent to your email if there is an account associated with it.': '',
  'Sorry, page not found': '',
  'Upload': '',
  'Add Folder': '',
  'Password changed. You can now log in.': '',
  'Sorry, data not found': '',
  'Date': '',
  'Time': '',
  'Continue': '',
  'Backend connected.': '',
  'Backend disconnected.': '',
  'Logout successfully.': '',
  'No response from the server': '',
  'Something went wrong': '',
  'When application is being selected, this product will become available only for it <br> becoming automatically unavailable for all applications not being selected. <br> When no application is selected, then product is available for all.': '',

  // iCount
  'Configure iCount invoices system.': '',
  'Send Email to Customer': '',
  'Ignore PoS Guests': '',
  'CID': '',
  'User': '',
  'No documents to display': '',
  'Reference': '',
  'iCount number': '',
  'Resending document to iCount': '',
  'Plugins': '',
  'Here you can setup plugins configurations': '',
  'No plugins installed or enabled': '',
  'Plugins settings saved': '',
  'Document Language': '',
  'Send SMS to Customer': '',
  'SMS Prefix': '',
  'SMS Suffix': '',
  'Sort Order': '',
  'Buzz on print': '',
  'Open cash drawer on print': '',
  'Amount': '',
  'Included Discounts': '',
  'Total Discounts': '',
  'Shipped items': '',
  'Applied Coupons': '',
  'No inventoriable variants': '',
  'Adjust': '',
  'Unable to update quantity for {0}': '',
  'Manage Inventory': ''
}
